import { DocumentSliceNode } from './DocumentSliceNode';
import {orderBy} from 'lodash';

export class DocumentSliceHierarchy {
  _data: any[];
  _typeStructure: string[];
  _typeFields: Map<string, any>;
  _nodes: DocumentSliceNode[];

  constructor(data?: any[], structure?: string[], nodes?: DocumentSliceNode[]) {
    this._data = data || [];
    this._typeStructure = structure || [];
    this._typeFields = new Map<string, any>([
      ['fund', { id: 'fundId', name: 'fundName' }],
      ['investor', { id: 'investorId', name: 'investorName' }],
      ['classification', { id: 'classificationId', name: 'classificationName' }],
      ['period', { period: 'publishPeriod', year: 'publishYear' }],
    ]);
    this._nodes = nodes || [];
  }

  sortChildren = (data): any => {
    if (data && data.children && data.children.length < 1) return data;
    if (data && data.children && data.children.length > 0){
      data.children = orderBy(data.children, ['name'], ['asc']);
      data.children = data.children.map((child) => {
        return this.sortChildren(child);
      })
    }
    return data;
  }

  generate = (data?: any[], typeStructure?: string[]): DocumentSliceNode[] => {
    this._data = data || this._data;
    this._typeStructure = typeStructure || this._typeStructure;

    this._nodes = new Array<DocumentSliceNode>();
    if (this._data.length === 0 || this._typeStructure.length === 0) return this._nodes;

    let lookup = new Map<string, boolean>();
    let type = this._typeStructure[0];
    let fields = this._typeFields.get(type);

    for (let i = 0; i < this._data.length; i++) {
      let item = this._data[i];
      if (type === 'period') {
        if (!lookup.get(`${item[fields.period]}_${item[fields.year]}`)) {
          const node = new DocumentSliceNode(`${item[fields.period]}_${item[fields.year]}`, `${item[fields.year]} Q${item[fields.period]}`, type, null);
          this._descendentNodes(node);
          this._nodes.push(node);
          lookup.set(`${item[fields.period]}_${item[fields.year]}`, true);
        }
      } else {
        if (!lookup.get(item[fields.id])) {
          const node = new DocumentSliceNode(item[fields.id], item[fields.name], type, null);
          this._descendentNodes(node);
          this._nodes.push(node);
          lookup.set(item[fields.id], true);
        }
      }
    }
    return this._nodes.map((node) => {
      return this.sortChildren(node);
    });
  }

  addChildren = (data: any[], typeStructure: string[], clickedNode: DocumentSliceNode, nodes?: DocumentSliceNode[]): void => {
    const lastSlice = typeStructure[typeStructure.length - 1];
    nodes &&
      nodes.forEach((i) => {
        if (i.type === lastSlice && i.nodeId === clickedNode.nodeId) {
          i.children = [...data];
        } else {
          this.addChildren(data, typeStructure, clickedNode, i.children);
        }
      });
  }

  _descendentNodes = (parent: DocumentSliceNode): void => {
    if (parent.level + 1 >= this._typeStructure.length) return;

    let ancestors = parent.ancestors();
    ancestors.push(parent);

    let type = this._typeStructure[parent.level + 1];
    let fields = this._typeFields.get(type);

    for (let i = 0; i < this._data.length; i++) {
      let item = this._data[i];
      if (this._isDescendent(item, ancestors)) {
        let child;
        if (type === 'period') {
          child = parent.addChild(`${item[fields.period]}_${item[fields.year]}`, `${item[fields.year]} Q${item[fields.period]}`, type);
        } else child = parent.addChild(item[fields.id], item[fields.name], type);
        this._descendentNodes(child);
      }
    }
  }

  _isDescendent = (item, ancestors: DocumentSliceNode[]): boolean => {
    for (let i = 0; i < ancestors.length; i++) {
      let ancestor = ancestors[i];
      let fields = this._typeFields.get(ancestor.type);
      if (ancestor.type === 'period') {
        let periodId = item[fields.period] + '_' + item[fields.year];
        if (periodId !== ancestor.id) return false;
      } else if (item[fields.id] !== ancestor.id) return false;
    }
    return true;
  }
}
